import { combineReducers } from 'redux';
import search from './peopleSearchReducer.js';
import fields from './fieldsReducer.js';
export default combineReducers({
  search,
  fields,
});



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/PeopleSearch/reducers/index.js
 **/